import { Colors } from '@amelio/ui-library';

import { MAX_NODES } from '../../ReviewerNodes';
import { OverflowNode } from '../OverflowNode/OverflowNode';
import { TreeNode } from '../TreeNode/TreeNode';

import type { DesktopTreeViewProps } from '../../types';

export const DesktopTreeView = ({
    centerNode,
    hasOverflow,
    allSatelliteNodes,
    hiddenNodes,
    onRemove,
    dataTestId,
}: DesktopTreeViewProps) => {
    const visibleSatelliteNodes = hasOverflow
        ? allSatelliteNodes?.slice(0, MAX_NODES)
        : allSatelliteNodes;

    return (
        <div data-testid={dataTestId}>
            <div className={`flex flex-1 flex-col items-center justify-center p-8`}>
                <div className={`relative h-120 w-full overflow-visible`}>
                    {/* SVG for connecting lines */}
                    <svg className={'pointer-events-none absolute inset-0 z-1 h-full w-full'}>
                        {centerNode &&
                            visibleSatelliteNodes.map((node) => {
                                return (
                                    <line
                                        key={`line-${node.data?.id}`}
                                        x1={`${centerNode.x}%`}
                                        y1={`${centerNode.y}%`}
                                        x2={`${node.x}%`}
                                        y2={`${node.y}%`}
                                        stroke={Colors.PRIMARY}
                                        strokeWidth={'3'}
                                        strokeOpacity={'1'}
                                        strokeDasharray={'1 1'}
                                        className={'transition-all duration-500'}
                                    />
                                );
                            })}

                        {/* Line for overflow node */}
                        {centerNode && hasOverflow && visibleSatelliteNodes.length > 0 && (
                            <line
                                x1={`${centerNode.x}%`}
                                y1={`${centerNode.y}%`}
                                x2={`${visibleSatelliteNodes[visibleSatelliteNodes.length - 1].x}%`}
                                y2={`${visibleSatelliteNodes[visibleSatelliteNodes.length - 1].y}%`}
                                stroke={Colors.PRIMARY}
                                strokeWidth={'3'}
                                strokeOpacity={'1'}
                                strokeDasharray={'1 1'}
                                className={'transition-all duration-500'}
                            />
                        )}
                    </svg>

                    {/* Center Node */}
                    {centerNode && centerNode.data && (
                        <TreeNode
                            key={centerNode.data?.id}
                            node={centerNode}
                            onRemove={onRemove}
                            dataTestId={'center-tree-node'}
                        />
                    )}

                    {/* Visible Satellite Nodes */}
                    {visibleSatelliteNodes
                        .slice(0, hasOverflow ? MAX_NODES - 1 : MAX_NODES)
                        .map((node) => (
                            <TreeNode
                                key={node.data?.id}
                                node={node}
                                onRemove={onRemove}
                                dataTestId={`satellite-tree-node-${node.data?.id}`}
                            />
                        ))}

                    {/* Overflow Node */}
                    {hasOverflow && visibleSatelliteNodes.length > 0 && (
                        <OverflowNode
                            position={{
                                x: visibleSatelliteNodes[MAX_NODES - 1].x,
                                y: visibleSatelliteNodes[MAX_NODES - 1].y,
                            }}
                            hiddenNodes={hiddenNodes}
                            count={hiddenNodes?.length}
                            onRemove={onRemove}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
